import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Header } from '../../components/header';
import Setting from '../../components/setting';
import { Help, Time, User } from '../../components/header/components';
import { appSettingsData } from './app-settings-data';
import { AppSettingsDatum } from './types';
import { setTimeFormat, setDateFormat, setTimeZone, getGlobalUserPreferences, getCustomUserPreferences } from '../../store/user-preferences-v2/actions';
import { AppState, AppThunkDispatch } from '../../store';


type FluidAttributes = { [index: string]: { values: string; callback: Function } };

const AppSettings = () => {
  const dispatch: AppThunkDispatch = useDispatch();
  const timeFormatValue = useSelector(
    (state: AppState) => state.userPreference.globalUserPreferences.timeFormat,
  );
  const dateFormatValue = useSelector(
    (state: AppState) => state.userPreference.globalUserPreferences.dateFormat,
  );
  const timeZoneValue = useSelector(
    (state: AppState) => state.userPreference.customUserPreferences.timeZone,
  );
  const fluidAttributes: FluidAttributes = {
    'Time Format': { values: timeFormatValue || '', callback: setTimeFormat },
    'Date Format': { values: dateFormatValue || '', callback: setDateFormat },
    'Time Zone': { values: timeZoneValue || '', callback: setTimeZone },
  };
  useEffect(() => {
    dispatch(getGlobalUserPreferences());
    dispatch(getCustomUserPreferences());
  });

  return (
    <>
      <Header title="Settings"
        headerComponents={[<Help userLink='/SitePages/Setting-Manual.aspx?promotedState=0'/>, <Time suppressPopover />, <User />]}
      />
      <Box p={4}>
        {appSettingsData.map((section: AppSettingsDatum) => (
          <Box pb={3} style={{ maxWidth: '800px' }}>
            <div key={section.sectionTitle}>
              {section.sectionComponents ? section.sectionComponents({}, null) : <></>}
              {section.selects.map((select: any) => {
                const attributes = fluidAttributes[select.title];
                if (attributes)
                  return (
                    <Setting
                      key={`${section.sectionTitle}-${select.title}`}
                      select={select}
                      id={select.title}
                      value={attributes.values}
                      callback={(value: any) => dispatch(attributes.callback(value))}
                    />
                  );
                return null;
              })}
            </div>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default AppSettings;
